import { useTracking } from 'react-tracking';
import { useAuthenticationRedirect } from '@/hooks/useAuthenticationRedirect';
import { useDispatch } from 'react-redux';
import { redirect } from 'redux-first-router';
import { ROUTE_DASHBOARD, ROUTE_WELCOME } from '@/constants/routes';

export const Home = () => {
  const { trackEvent } = useTracking();
  const dispatch = useDispatch();
  useAuthenticationRedirect({
    onRedirect() {
      dispatch(redirect({ type: ROUTE_DASHBOARD }));
    },
    onUnauthenticated() {
      trackEvent({
        type: 'track',
        page: 'home',
        subject: 'page',
        action: 'landed',
      });
      dispatch(redirect({ type: ROUTE_WELCOME }));
    },
  });

  return <></>;
};
